import { useCallback, useEffect, useState } from 'react';
import { BarChart } from './Components/BarChart';
import { DonutChart } from './Components/DonutChart';
import { LineChart } from './Components/LineChart';
import { LiveInfo } from './Components/LiveInfo';

export const Dashboard = ({ data, date, loading }) => {
  const [availableData, setAvailableData] = useState({
    biogas: 1,
    wind: 1,
    pv: 1,
    consumed: 1,
  });

  const { wind, pv, consumed, biogas } = availableData;

  const getData = useCallback(
    (dataInfo) => {
      return (
        data &&
        dataInfo.filter(
          (reading) =>
            parseInt(reading.date.split('T')[1].split('.')[0].split(':')[0]) ===
              parseInt(
                `${date.getHours() < 10 ? '0' : ''}${date.getHours()}`
              ) &&
            Math.abs(
              parseInt(reading.date.split('T')[1].split('.')[0].split(':')[1]) -
                parseInt(
                  `${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}`
                )
            ) <= 15
        )
      );
    },
    [date, data]
  );

  const getValues = useCallback(
    (dataInfo) => {
      return data && getData(dataInfo).length > 0
        ? getData(dataInfo)[getData(dataInfo).length - 1].value
        : 0;
    },
    [data, getData]
  );

  useEffect(() => {
    if (data) {
      setAvailableData({
        biogas: getValues(data.biomassFacility.production.readings),
        wind: getValues(data.windFacility.production.readings),
        // pv: getValues(data.solarFacility.production.readings) * 1.67,
        pv:
          data &&
          (data.solarFacility.production.readings.length > 0
            ? data.solarFacility.production.readings[
                data.solarFacility.production.readings.length - 1
              ].value
            : 0) * 1.67,
        consumed: getValues(data.village.consumption.readings),
      });
    }
  }, [data, getValues]);

  return (
    <div className='row m-0 mx-2'>
      <section className='col-lg-6 '>
        <LiveInfo wind={wind} biogas={biogas} pv={pv} consumed={consumed} />
        <div className='row'>
          <DonutChart
            wind={wind}
            biogas={biogas}
            pv={pv}
            allData={data}
            loading={loading}
          />
          <BarChart
            wind={wind}
            biogas={biogas}
            pv={pv}
            consumed={consumed}
            allData={data}
            loading={loading}
          />
        </div>
      </section>
      <section className='col-lg-6'>
        <LineChart allData={data} date={date} />
      </section>
    </div>
  );
};
